const { getDashboard, getReports, getBalance, setOpeningBalance } = require('@/controllers/reports').ct_reports;

const initialState = () => ({
    dashboard: null,
    reports: [],
    reports_summary: {},
    reports_pagination: {},
    balance: null,
});

const state = initialState();

const mutations = {
    SET_DASHBOARD(state, dashboard) {
        state.dashboard = dashboard;
    },
    SET_REPORTS(state, { data, summary = {}, pagination = {} }) {
        state.reports = data;
        state.reports_summary = summary;
        state.reports_pagination = pagination;
    },
    SET_BALANCE(state, balance) {
        state.balance = balance;
    },
    RESET_REPORTS_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_dashboard(state) {
        return state.dashboard;
    },
    get_reports(state) {
        return {
            data: state.reports,
            summary: state.reports_summary,
            pagination: state.reports_pagination,
        };
    },
    get_balance(state) {
        return state.balance;
    },
};

const actions = {
    // params: { year, month, day } (Resumo geral)
    async load_dashboard({ commit }, params = {}) {
        const response = await getDashboard(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_DASHBOARD', response.data);
        return response.data;
    },

    async load_reports({ commit }, params = {}) {
        const response = await getReports(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_REPORTS', response);
        return response;
    },

    async load_balance({ commit }) {
        const response = await getBalance();

        if (!response.status) {
            throw response.error;
        }

        commit('SET_BALANCE', response.data);
        return response.data;
    },

    // payload: { stock_value, bank, cash }
    async set_opening_balance({ dispatch }, payload) {
        const response = await setOpeningBalance(payload);

        if (!response.status) {
            throw response.error;
        }

        await dispatch('load_balance');
        return response.data;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
